<template>
  <div class="bg-brand-taupe-500">
    <PageHeader :headingContent="headingContent" />
    <div class="px-4 pb-20">
      <flash-messages />
      <div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100 p-6">
        The list below shows any invitations that have been sent but haven't yet been
        actioned by the invitees, to send them a reminder email (with a new link) just
        click the "Send Reminder" button next to their row.
        <div class="overflow-auto">
          <div v-if="invitations.length > 0" class="table table-auto w-full">
            <div class="table-header-group">
              <div class="table-row">
                <div
                  class="table-cell font-display font-semibold text-brand-blue-400 uppercase"
                >
                  Email
                </div>
                <div
                  class="table-cell font-display font-semibold text-brand-blue-400 uppercase"
                >
                  Last Invited at
                </div>
                <div
                  class="table-cell font-display font-semibold text-brand-blue-400 uppercase"
                >
                  Invited by
                </div>

                <div class="table-cell">&nbsp;</div>
              </div>
            </div>
            <div class="table-row-group">
              <div
                v-for="invitation in invitations"
                class="table-row divide-y"
                :key="invitation.id"
              >
                <div class="table-cell">{{ invitation.email }}</div>
                <div class="table-cell">
                  {{ $moment(invitation.created_at).format("DD MMM YYYY HH:mm") }}
                  <span v-if="invitation.last_sent_at" class="italic text-xs">
                    (Last reminded on
                    {{ $moment(invitation.last_sent_at).format("DD MMM YYYY HH:mm") }})
                  </span>
                </div>
                <div class="table-cell">
                  {{ invitation.invited_by.first_name }}
                  {{ invitation.invited_by.last_name }}
                </div>
                <div class="table-cell">
                  <button
                    class="bg-brand-green-400 hover:bg-brand-green-200 text-white font-bold text-sm py-2 px-4 rounded uppercase mb-4"
                    @click="onSendReminder(invitation.id)"
                  >
                    Send reminder
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/Shared/PageHeader";
import { Inertia } from "@inertiajs/inertia";
import Layout from "@/Shared/Layouts/Admin/Layout";
import FlashMessages from "@/Shared/FlashMessages";

export default {
  components: {
    PageHeader,
    FlashMessages,
  },
  layout: Layout,
  methods: {
    onSendReminder(invitationId) {
      Inertia.put("/admin/invitations/" + invitationId);
    },
  },
  name: "Admin-Reminders",
  props: {
    invitations: {
      default: [],
      required: true,
      type: Array,
    },
  },
  setup() {
    const headingContent = {
      hero: {
        image: "/images/263918963_cars_hero.jpg",
        title: "Fleet Risk Review",
        subtitle: "In association with AXA Insurance",
      },
      page: {
        title: "Invitation Reminders",
        subtitle: "",
      },
    };
    return {
      headingContent,
    };
  },
};
</script>
